import api from '../axios';

export const get_users = async () => {
  try {
    const response = await api.get('/users');
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return null;
  }
};

export const post_user = async (data) => {
  try {
    const response = await api.post('/users', data);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    return null;
  }
};

export const update_user = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.patch(`/users/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    return null;
  }
};

export const delete_user = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.delete(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    return null;
  }
};
